import { render, staticRenderFns } from "./SecondSidebarItem.vue?vue&type=template&id=74ddc4d0&scoped=true"
import script from "./SecondSidebarItem.vue?vue&type=script&lang=js"
export * from "./SecondSidebarItem.vue?vue&type=script&lang=js"
import style0 from "./SecondSidebarItem.vue?vue&type=style&index=0&id=74ddc4d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ddc4d0",
  null
  
)

export default component.exports